// extracted by mini-css-extract-plugin
export default {"footer":"footer___1eYqx","text":"text___3yTmG","icons":"icons___jqOch","icon":"icon___2qJL6","links":"links___1BXhs","list":"list___2Wogm"};